import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { fade } from '@material-ui/core/styles/colorManipulator';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import Link from '@material-ui/core/Link';
import Popover from '@material-ui/core/Popover';
import Info from '@material-ui/icons/Info';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import { DeleteIcon } from 'theme/icons';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showModal } from 'redux/modules/modal';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	container: {
		padding: `${6 * theme.spacing.unit}px ${8 * theme.spacing.unit}px`,
	},
	paper: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		height: '100%'
	},
	tabsPaper: {
		background: '#eee'
	},
	inheritButton: {
		color: theme.palette.common.white,
		backgroundColor: '#4acfce',
		'&:disabled': {
			backgroundColor: fade('#4acfce', 0.3)
		},
		'&:hover': {
			backgroundColor: '#80ffff',
		}
	},
	flexColumnList: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	flexRowList: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center'
	},
	table: {
		tableLayout: 'fixed'
	},
	tableAccountCell: {
		width: 160
	},
	tableActionsCell: {
		width: 50
	}
});

@withStyles(styles)
class Showcase extends Component {

	constructor(props) {
		super(props);
		this.triggerModal = this.triggerModal.bind(this);
		this.state = {
			infoAnchor: null,
			tabValue: 0
		};
	}


	render() {
		const { classes } = this.props;

		return (
			<div className={classes.container}>
				<Grid container spacing={16} alignItems='stretch'>
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<Typography variant='h1' gutterBottom>{localize('showcase-headline1')}</Typography>

							<Typography variant='h2' gutterBottom>{localize('showcase-headline2')}</Typography>

							<Typography variant='h3' gutterBottom>{localize('showcase-headline3')}</Typography>

							<Typography variant='caption' gutterBottom>{localize('showcase-caption')}</Typography>

							<Typography variant='subtitle1' gutterBottom>{localize('showcase-explanation')}</Typography>

							<Typography variant='body1' gutterBottom>{localize('showcase-body1')}</Typography>

							<Typography variant='body2'>{localize('showcase-body2')}</Typography>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classNames(classes.paper, classes.flexColumnList)}>
							<Button variant='contained' color='primary' size='small'>{localize('save')}</Button>
							<Button variant='contained' color='primary' size='small' disabled>{localize('save')}</Button>

							<Button variant='contained' color='secondary' size='small'>{localize('delete')}</Button>
							<Button variant='contained' color='secondary' size='small' disabled>{localize('delete')}</Button>

							<Button
								variant='contained'
								color='inherit'
								size='small'
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>
							<Button
								variant='contained'
								color='inherit'
								size='small'
								disabled
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>

							<Button variant='contained' size='small'>{localize('cancel')}</Button>
							<Button variant='contained' size='small' disabled>{localize('cancel')}</Button>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classNames(classes.paper, classes.flexColumnList)}>
							<Button variant='contained' color='primary'>{localize('save')}</Button>
							<Button variant='contained' color='primary' disabled>{localize('save')}</Button>

							<Button variant='contained' color='secondary'>{localize('delete')}</Button>
							<Button variant='contained' color='secondary' disabled>{localize('delete')}</Button>

							<Button
								variant='contained'
								color='inherit'
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>
							<Button
								variant='contained'
								color='inherit'
								disabled
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>

							<Button variant='contained'>{localize('cancel')}</Button>
							<Button variant='contained' disabled>{localize('cancel')}</Button>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classNames(classes.paper, classes.flexColumnList)}>
							<Button variant='contained' color='primary' size='large'>{localize('save')}</Button>
							<Button variant='contained' color='primary' size='large' disabled>{localize('save')}</Button>

							<Button variant='contained' color='secondary' size='large'>{localize('delete')}</Button>
							<Button variant='contained' color='secondary' size='large' disabled>{localize('delete')}</Button>

							<Button
								variant='contained'
								color='inherit'
								size='large'
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>
							<Button
								variant='contained'
								color='inherit'
								size='large'
								disabled
								className={classes.inheritButton}
							>
								{localize('showcase-launch-editor')}
							</Button>

							<Button variant='contained' size='large'>{localize('cancel')}</Button>
							<Button variant='contained' size='large' disabled>{localize('cancel')}</Button>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classNames(classes.paper, classes.flexColumnList)}>
							<Grid container spacing={8}>
								<Grid item xs={3}>
									<TextField
										id='email'
										name='email'
										type='email'
										placeholder={localize('showcase-email-placeholder')}
										fullWidth
										InputProps={{
											disableUnderline: true
										}}
									/>
								</Grid>
								<Grid item xs={3}>
									<TextField
										id='email2'
										name='email2'
										type='email'
										placeholder={localize('showcase-email-placeholder')}
										value={localize('showcase-email-value')}
										fullWidth
										InputProps={{
											disableUnderline: true
										}}
									/>
								</Grid>
								<Grid item xs={3}>
									<TextField
										id='disabled'
										name='disabled'
										placeholder={localize('showcase-disabled-placeholder')}
										value={localize('showcase-disabled-value')}
										disabled
										fullWidth
										InputProps={{
											disableUnderline: true
										}}
									/>
								</Grid>
								<Grid item xs={3}>
									<Select
										value=''
										name="age"
										displayEmpty
										disableUnderline
										fullWidth
										IconComponent={SelectArrow}
									>
										<MenuItem value="" disabled>
											{localize('showcase-select-placeholder')}
										</MenuItem>
										<MenuItem value={10}>{localize('showcase-select-option-10')}</MenuItem>
										<MenuItem value={20}>{localize('showcase-select-option-20')}</MenuItem>
										<MenuItem value={30}>{localize('showcase-select-option-30')}</MenuItem>
									</Select>
								</Grid>
								<Grid item xs={12}>
									<TextField
										placeholder={localize('showcase-multiline-placeholder')}
										multiline
										rows='4'
										fullWidth
										InputProps={{
											disableUnderline: true
										}}
									/>
								</Grid>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classNames(classes.paper, classes.flexColumnList)}>
							<Grid container spacing={8}>
								<Grid item xs={4} className={classes.flexRowList}>
									<Link
										variant='body1'
										onClick={this.triggerModal(
											'CONFIRMATION_MODAL',
											localize('showcase-confirmation-popup-title'),
											{
												__html: localize('showcase-confirmation-popup-message'),
											},
											[
												<Button
													key='button-cancel'
													variant='outlined'
													color='primary'
													onClick={() => {}}
												>
													{localize('cancel')}
												</Button>,
												<Button
													key='button-confirm'
													variant='contained'
													color='primary'
													onClick={() => {}}
												>
													{localize('showcase-confirmation-popup-confirm')}
												</Button>
											]
										)}
									>
										{localize('showcase-confirmation-popup')}
									</Link>
								</Grid>
								<Grid item xs={4} className={classes.flexRowList}>
									{/* Error popups get shown automatically, usually you don't need to trigger it manually. */}
									<Link
										variant='body1'
										color='inherit'
										onClick={this.triggerModal('ERROR_MODAL')}
									>
										{localize('showcase-error-popup')}
									</Link>
								</Grid>
								<Grid item xs={4} className={classes.flexRowList}>
									<Typography variant='body1' inline>{localize('showcase-info-link')}</Typography>&nbsp;
									<Info
										color='primary'
										aria-owns={this.state.infoAnchor ? 'info-popover' : undefined}
										aria-haspopup='true'
										onClick={event => this.setState({ infoAnchor: event.target })}
									/>
									<Popover
										id='info-popover'
										className={classes.popover}
										open={!!this.state.infoAnchor}
										anchorEl={this.state.infoAnchor}
										anchorOrigin={{
											vertical: 'top',
											horizontal: 'center'
										}}
										transformOrigin={{
											vertical: 'bottom',
											horizontal: 'center'
										}}
										onClose={() => this.setState({ infoAnchor: null })}
										disableRestoreFocus
									>
										<Typography variant='subtitle1' gutterBottom>
											{localize('showcase-info-title')}
										</Typography>
										<Typography
											variant='body2'
											dangerouslySetInnerHTML={{ __html: localize('showcase-info-text1') }}
										/>
										<Typography
											variant='body2'
											dangerouslySetInnerHTML={{ __html: localize('showcase-info-text2') }}
										/>
										<Typography
											variant='body2'
											dangerouslySetInnerHTML={{ __html: localize('showcase-info-text3') }}
										/>
									</Popover>
								</Grid>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classNames(classes.paper, classes.tabsPaper)}>
							<Tabs value={this.state.tabValue} onChange={(event, value) => this.setState({ tabValue: value })}>
								<Tab label={localize('showcase-tab1')} disableRipple />
								<Tab label={localize('showcase-tab2')} disableRipple />
								<Tab label={localize('showcase-tab3')} disableRipple />
							</Tabs>
							<Paper elevation={0} square style={{ padding: 20 }}>
								{this.state.tabValue === 0 &&
									<Typography variant='body2'>{localize('showcase-tab1')}</Typography>}
								{this.state.tabValue === 1 &&
									<Typography variant='body2'>{localize('showcase-tab2')}</Typography>}
								{this.state.tabValue === 2 &&
									<Typography variant='body2'>{localize('showcase-tab3')}</Typography>}
							</Paper>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classNames(classes.paper)}>
							<Table className={classes.table}>
								<TableHead>
									<TableRow>
										<TableCell>{localize('showcase-table-head-email')}</TableCell>
										<TableCell className={classes.tableAccountCell} align='center'>
											{localize('showcase-table-head-account-type')}
										</TableCell>
										<TableCell className={classes.tableActionsCell} align='right'/>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow hover>
										<TableCell>{localize('showcase-table-body-email')}</TableCell>
										<TableCell align='center' padding='dense'>
											<Select
												value='10'
												name="accountType"
												displayEmpty
												disableUnderline
												fullWidth
												IconComponent={SelectArrow}
											>
												<MenuItem value="" disabled>
													{localize('showcase-table-select-option1')}
												</MenuItem>
												<MenuItem value={10}>{localize('showcase-table-select-option2')}</MenuItem>
												<MenuItem value={20}>{localize('showcase-table-select-option3')}</MenuItem>
											</Select>
										</TableCell>
										<TableCell align='right' padding='none'>
											<IconButton color='secondary' component='span' disableRipple>
												<DeleteIcon />
											</IconButton>
										</TableCell>
									</TableRow>
									<TableRow hover>
										<TableCell>{localize('showcase-table-body-email')}</TableCell>
										<TableCell align='center' padding='dense'>
											<Select
												value='20'
												name="accountType"
												displayEmpty
												disableUnderline
												fullWidth
												IconComponent={SelectArrow}
											>
												<MenuItem value="" disabled>
													{localize('showcase-table-select-option1')}
												</MenuItem>
												<MenuItem value={10}>{localize('showcase-table-select-option2')}</MenuItem>
												<MenuItem value={20}>{localize('showcase-table-select-option3')}</MenuItem>
											</Select>
										</TableCell>
										<TableCell align='right' padding='none'>
											<IconButton color='secondary' component='span' disableRipple>
												<DeleteIcon />
											</IconButton>
										</TableCell>
									</TableRow>
									<TableRow hover>
										<TableCell>{localize('showcase-table-body-email')}</TableCell>
										<TableCell align='center' padding='dense'>
											<Select
												value='10'
												name="accountType"
												displayEmpty
												disableUnderline
												fullWidth
												IconComponent={SelectArrow}
											>
												<MenuItem value="" disabled>
													{localize('showcase-table-select-option1')}
												</MenuItem>
												<MenuItem value={10}>{localize('showcase-table-select-option2')}</MenuItem>
												<MenuItem value={20}>{localize('showcase-table-select-option3')}</MenuItem>
											</Select>
										</TableCell>
										<TableCell align='right' padding='none'>
											<IconButton color='secondary' component='span' disableRipple>
												<DeleteIcon />
											</IconButton>
										</TableCell>
									</TableRow>
									<TableRow hover>
										<TableCell>{localize('showcase-table-body-email')}</TableCell>
										<TableCell align='center' padding='dense'>
											<Select
												value='20'
												name="accountType"
												displayEmpty
												disableUnderline
												fullWidth
												IconComponent={SelectArrow}
											>
												<MenuItem value="" disabled>
													{localize('showcase-table-select-option1')}
												</MenuItem>
												<MenuItem value={10}>{localize('showcase-table-select-option2')}</MenuItem>
												<MenuItem value={20}>{localize('showcase-table-select-option3')}</MenuItem>
											</Select>
										</TableCell>
										<TableCell align='right' padding='none'>
											<IconButton color='secondary' component='span' disableRipple>
												<DeleteIcon />
											</IconButton>
										</TableCell>
									</TableRow>
									<TableRow hover>
										<TableCell>{localize('showcase-table-body-email')}</TableCell>
										<TableCell align='center' padding='dense'>
											<Select
												value='10'
												name="accountType"
												displayEmpty
												disableUnderline
												fullWidth
												IconComponent={SelectArrow}
											>
												<MenuItem value="" disabled>
													{localize('showcase-table-select-option1')}
												</MenuItem>
												<MenuItem value={10}>{localize('showcase-table-select-option2')}</MenuItem>
												<MenuItem value={20}>{localize('showcase-table-select-option3')}</MenuItem>
											</Select>
										</TableCell>
										<TableCell align='right' padding='none'>
											<IconButton color='secondary' component='span' disableRipple>
												<DeleteIcon />
											</IconButton>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</Paper>
					</Grid>
				</Grid>
			</div>
		);
	}

	triggerModal(modalType, title, message, buttons) {
		return () => {
			this.props.showModal(modalType, { title, message, buttons });
		};
	}

}

Showcase.propTypes = {
	classes: PropTypes.object,
	showModal: PropTypes.func
};

const mapDispatchToProps = dispatch => bindActionCreators({
	showModal
}, dispatch);

export default connect(
	null,
	mapDispatchToProps
)(Showcase);


// WEBPACK FOOTER //
// ./src/containers/Showcase/Showcase.js